import type { z } from 'zod';

import type { UserNoteSchema } from './schemas';

type UserNoteField = keyof z.infer<typeof UserNoteSchema>;

const listAttributes = [
  'id',
  'type',
  'ownerId',
  'creationDatetime',
  'note',
  'lastEditDatetime',
  'priorityDatetime',
  'dueDatetime',
  'creatorName',
  'createdBy',
  'createdBySystem',
  'assigneeName',
  'assigneeId',
  'active',
  'billingRelated',
] as const satisfies readonly UserNoteField[];

const getAttributes = [...listAttributes] as const satisfies readonly UserNoteField[];

const updateAttributes = [
  'note',
  'assigneeId',
  'assigneeName',
  'billingRelated',
  'active',
  'lastEditDatetime',
  'dueDatetime',
  'priorityDatetime',
] as const satisfies readonly UserNoteField[];

export const UserNoteAttributes = {
  List: listAttributes,
  Get: getAttributes,
  Update: updateAttributes,
};
